// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2A0KN","search":"Settings_search__2ful6","filter":"Settings_filter__3-C_C"};